import { safeLocalGet, safeLocalSet } from './dom';


// How long a closed announcement stays closed for that visitor. The Dato
// `campaign` key scopes it, so a new announcement is seen even by visitors
// who closed the previous one.
export const ANNOUNCEMENT_DISMISSAL_DAYS = 7;
export const ANNOUNCEMENT_STORAGE_PREFIX = 'announcementDismissed';

const DAY_IN_MS = 24 * 60 * 60 * 1000;
const DATO_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

export const getAnnouncementStorageKey = (campaign) => `${ANNOUNCEMENT_STORAGE_PREFIX}:${campaign}`;

// Anything that is not a well-formed, recent envelope counts as "not
// dismissed": a hand-edited value or blocked storage must never throw, and
// showing the card once too often is the harmless direction.
export const isAnnouncementDismissed = (campaign, now = Date.now()) => {
  const stored = safeLocalGet(getAnnouncementStorageKey(campaign));
  if (typeof stored !== 'string') return false;

  try {
    const { dismissedAt } = JSON.parse(stored);
    if (typeof dismissedAt !== 'number') return false;

    return now - dismissedAt < ANNOUNCEMENT_DISMISSAL_DAYS * DAY_IN_MS;
  } catch (e) {
    return false;
  }
};

export const dismissAnnouncement = (campaign, now = Date.now()) => {
  safeLocalSet(getAnnouncementStorageKey(campaign), JSON.stringify({ dismissedAt: now }));
};

// Dato date fields arrive as YYYY-MM-DD. Parsed as local midnight on purpose:
// the hotel enters the first day the card should be gone, and the visitor's
// own calendar day is the one they can see. Anything else is treated as
// "no date".
const parseLocalDate = (value) => {
  const match = typeof value === 'string' ? value.match(DATO_DATE_PATTERN) : null;
  if (!match) return null;

  const [, year, month, day] = match;
  const time = new Date(Number(year), Number(month) - 1, Number(day)).getTime();
  return Number.isNaN(time) ? null : time;
};

export const isAnnouncementLive = ({ active, hideFrom }, now = Date.now()) => {
  if (active !== true) return false;

  const hideFromTime = parseLocalDate(hideFrom);
  return hideFromTime === null || now < hideFromTime;
};
